import React, { useState } from 'react';

export default function MobileProviderSettings({ onBack }) {
  const [settings, setSettings] = useState({
    uploadNotifications: true,
    patientAccepted: true,
    patientRejected: true,
    emailAlerts: false,
    biometric: false,
  });

  const toggle = (key) => setSettings(prev => ({ ...prev, [key]: !prev[key] }));

  const items = [
    { key: 'uploadNotifications', label: 'Upload Notifications',  desc: 'Notify when report is sent',         section: 'Notifications' },
    { key: 'patientAccepted',     label: 'Patient Accepted',       desc: 'Alert when patient accepts report',  section: 'Notifications' },
    { key: 'patientRejected',     label: 'Patient Rejected',       desc: 'Alert when patient rejects report',  section: 'Notifications' },
    { key: 'emailAlerts',         label: 'Email Alerts',           desc: 'Send summary emails daily',          section: 'Communication' },
    { key: 'biometric',           label: 'Biometric Login',        desc: 'Use fingerprint or face unlock',     section: 'Security' },
  ];

  const sections = [...new Set(items.map(i => i.section))];

  return (
    <div className="pb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="flex items-center gap-3 px-4 py-4 bg-white border-b border-gray-100 shadow-sm">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100">
          <span className="material-symbols-outlined text-gray-500">arrow_back</span>
        </button>
        <p className="font-black text-lg text-[#141a3d]">Settings</p>
      </div>

      <div className="px-4 mt-4 space-y-5">
        {sections.map(section => (
          <div key={section}>
            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 px-1">{section}</p>
            <div className="bg-white rounded-2xl shadow-sm overflow-hidden divide-y divide-gray-100">
              {items.filter(i => i.section === section).map(item => (
                <div key={item.key} className="flex items-center justify-between px-4 py-3.5">
                  <div>
                    <p className="font-bold text-sm text-[#141a3d]">{item.label}</p>
                    <p className="text-xs text-gray-400 mt-0.5">{item.desc}</p>
                  </div>
                  <button onClick={() => toggle(item.key)}
                    className="relative w-12 h-6 rounded-full transition-all shrink-0 active:scale-95"
                    style={{ background: settings[item.key] ? '#0f6b5c' : '#e5e7eb' }}>
                    <span className="absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-all"
                      style={{ left: settings[item.key] ? '26px' : '2px' }} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}